import { Paper, Skeleton, Typography } from "@mui/material";
import useSWR from "swr";
import { fetchData } from "../../../../lib/dashboard/data";
import DomesticTable from "./DomesticTable";

const Domestic = () => {
  const inc = useSWR(
    "/dashboard/domestic-top-price-change?price_changes=inc",
    fetchData
  );

  const dec = useSWR(
    "/dashboard/domestic-top-price-change?price_changes=dec",
    fetchData
  );

  const isLoading = inc.isLoading || dec.isLoading;


  return (
    <Paper sx={{ minHeight: 505 }}>
      {isLoading ? <Skeleton variant='rounded' height={"100%"} /> :
        <>
          <Typography sx={{ mb: 2, fontWeight: 700 }}>بازار داخلی </Typography>
          <DomesticTable incData={inc.data || []} decData={dec.data || []} />
        </>
      }
    </Paper>
  );
};

export default Domestic;
